// axios
import axios from 'axios'

axios.defaults.withCredentials = true

const baseURL = ""

export default axios.create({
  baseURL: baseURL
  // You can add your headers here
})
